import React, { Component } from 'react';
//import './App.css';
import { Grid, Row, Col } from 'react-bootstrap';

class ChatBar extends Component {
  constructor(props) {
    super(props);
  	this.handleSend = this.handleSend.bind(this);
  }
  handleSend() {
  	if(this.refs.snmessage.value) {
	  	this.props.trigger(this.refs.snmessage.value);
	  	this.refs.snmessage.value = '';
	}
  }
  render() {
  	return (
  		<Row className="cht">
          <Col xs={12} md={12}>
            <div>
              <input className="chat-message" type="text" ref="snmessage"/> 
              <a href="#" onClick={this.handleSend}><img className="im" src="icons/send.png" width="25"/></a>
            </div>
          </Col>
        </Row>
  	);
  }
}

export default ChatBar;


// WEBPACK FOOTER //
// ./src/ChatBar.js